import React from "react";
import styled from "styled-components";
import media from "Styles/media";
const Wrapper = styled.div`
	padding: 0 ${(props) => `${props.theme.size.offset.pc * 2 + props.theme.size.logo.pc}px`};
	@media ${media.tablet} {
		padding: 0 ${(props) => `${props.theme.size.offset.tablet * 2 + props.theme.size.logo.tablet}px`};
	}
	@media ${media.mobile} {
		padding: 0 ${(props) => `${props.theme.size.offset.tablet}px`};
	}
`;
interface ContainerMdProps {
	className?: string;
}

const Inner = styled.div`
	width: 100%;
	margin: 0 auto;
	max-width: 1200px;
`;

const ContainerMd: React.FC<ContainerMdProps> = ({ children, className }) => {
	return (
		<Wrapper className={className}>
			<Inner>{children}</Inner>
		</Wrapper>
	);
};

export default ContainerMd;
